import { createContext } from 'react';
import type { ReactReduxContextValue } from '@atlassian/jira-react-redux';
import type { SectionsContext, State } from './types';

const defaultSectionsContext = {
	id: '',
	index: 0,
	sectionsData: [],
	totalWidth: 0,
	parent: null,
};

export default createContext<SectionsContext>(defaultSectionsContext);

// @ts-expect-error - TS2345 - Argument of type 'null' is not assignable to parameter of type
export const SectionContext = createContext<ReactReduxContextValue<Partial<State>>>(null);
